/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../../../../core/admin/settings/settings.services';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})

export class AuthLayoutComponent implements OnInit {


  settinfgData : any;
  logoImage : any;

  constructor(
    public service : SettingsService
  ) { }

  ngOnInit() {
    this.getData();
  }

  /**
  * @method -- get data
  */
  getData() {
    this.service.getSettings().subscribe((result : any) => {
      if(result && result.data) {
        this.settinfgData = result.data[0];
        if(this.settinfgData.cloudImageUrl && this.settinfgData.cloudImageFolder && this.settinfgData.storeLogoPath && this.settinfgData.storeLogo) {
          this.logoImage = this.settinfgData.cloudImageUrl + '' + this.settinfgData.cloudImageFolder + "/" + this.settinfgData.storeLogoPath  + "/"+  this.settinfgData.storeLogo;
        }
      }
    })
  }
}